<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-card class="pa-2" outlined>
          <v-card-title class="headline">Users</v-card-title>
          <v-card-subtitle class="display-1 text-primary">{{ users }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2" outlined>
          <v-card-title class="headline">Sessions</v-card-title>
          <v-card-subtitle class="display-1 text-success">{{ sessions }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2" outlined>
          <v-card-title class="headline">Pageviews</v-card-title>
          <v-card-subtitle class="display-1 text-info">{{ pageviews }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { axios } from '../../../utils'

export default {
  data() {
    return {
      users: 0, // Replace with dynamic data
      sessions: 0, // Replace with dynamic data
      pageviews: 0 // Replace with dynamic data
    };
  },
  mounted(){
    this.getNumbers()
  },
  methods: {
    getNumbers() {
        axios.get('/api/sessions-views')
        .then(res => {
            this.users = res.data.totals.users
            this.sessions = res.data.totals.sessions
            this.pageviews = res.data.totals.pageViews
        })
    }
  }
};
</script>

<style scoped>
.v-card-title {
  text-transform: uppercase;
  color: #424242;
}
.v-card-subtitle {
  color: #424242;
}
</style>
